
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M27.03 97V9h8v88M23.03 98h16v11h-16zM85 97V9h8v88M81 98h16v11H81zM31.03 1v7M89.06 1v7M85 18a25 25 0 01-50 0M118.5 43C105 43 93 32.06 93 18.56M36 71.5h48M93.06 71.5h25.44M1.5 71.5h25.28M51.06 42v30M69.06 42v30M109.06 41v31M1.5 43C15 43 27 32.06 27 18.56M11.02 41v31"}})])
          )
        }
      }
    